var exports = {};
exports = /^#!(.*)/;
export default exports;